import { Component } from '@angular/core';
import { NgForOf } from "@angular/common";
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.sass'
})
export class LanguageSelectorComponent {

  constructor(
    private translocoService: TranslocoService
  ) { }

  public languagesList: Array<
    Record<'imgUrl' | 'code' | 'name' | 'shorthand', string>
  > = [
    {
      imgUrl: '/assets/images/Deutsch.png',
      code: 'de',
      name: 'Deutsch',
      shorthand: 'GER',
    },
    {
      imgUrl: '/assets/images/English.png',
      code: 'en',
      name: 'English',
      shorthand: 'ENG',
    },
    {
      imgUrl: '/assets/images/Japanese.png',
      code: 'jp',
      name: 'やまと',
      shorthand: 'JPN',
    }
  ];

  public changeLanguage(languageCode: string): void {
    this.translocoService.setActiveLang(languageCode);
    languageCode === 'fa'
      ? (document.body.style.direction = 'rtl')
      : (document.body.style.direction = 'ltr');
  }

}
